module.exports = __webpack_public_path__ + "img/System_verification.04465867.png";